export default __webpack_public_path__ + "static/media/맨몸PT_웹.8331eeee.jpg";